/*
 * @author Maciej Sikora
 * @copyright BossByte Web Application
 */


app.controller('MessageReports', function($scope, $http, states, types,categories, _$filter, $timeout, _$breadcrumbs, _$report, _$toast) {



    //add all option
    //var allOpt={label:"Wszystkie",value:0};

    //types.unshift(allOpt);
    //states.unshift(allOpt);

    $scope.showLoader = false;
    $scope.list = [];
    $scope.sticky = {

        _getChecked: function() {

            return $scope.list.filter(function(el) {
                return el.checked;
            }).map(function(el) {
                return {
                    id: el.id
                }
            });
        },
        take: function() {

            _$report.sticky.adopt($scope.sticky._getChecked()).then(function() {

                _$toast.success("Zgłoszenia przyjęte");

                $scope.queryList();

            });

        },
        block: function() {


            _$report.sticky.block($scope.sticky._getChecked()).then(function() {

                _$toast.success("Zgłoszenia zablokowane");

                $scope.queryList();

            });
        },
        unBlock: function() {


            _$report.sticky.unblock($scope.sticky._getChecked()).then(function() {

                _$toast.success("Zgłoszenia odblokowane");

                $scope.queryList();

            });
        },
        connect: function() {

            //take only those not checked to list and not connected to other ones
            var list = $scope.list.filter(function(el) {

                return !el.checked && !el.connected_report_id;

            });

            if (list.length === 0) {

                _$toast.message("Na liście nie ma zgłoszeń do których można połączyć wybrane zgłoszenia.");
                return;
            }

            _$report.showConnectDialog(list).then(function(connectToId) {

                _$report.sticky.connect(connectToId, $scope.sticky._getChecked()).then(function() {

                    _$toast.success("Zgłoszenia połączone");

                    $scope.queryList();

                });

            });


        }
    };

    //paginator options
    $scope.paginator = {

        page: 1,
        count: 1
    };

    //callback on page change
    $scope.changePage = function() {

        $scope.queryList();
    };

    $scope.filters = {

        type: {

            model: {
                value: null,
                symbol: "type"
            },
            options: types
        },
        state: {

            model: {
                value: null,
                symbol: "state"
            },
            options: states
        },
        category: {
            model: {
                value: null,
                symbol: "category"
            },
            options: categories
        },
        assign: {

            model: {
                value: null,
                symbol: "assign"
            }

        },
        dateFrom: {

            model: {
                value: null,
                symbol: "dateFrom"
            }

        },
        dateTo: {

            model: {
                value: null,
                symbol: "dateTo"
            }

        }

    };


    $scope.queryAssign = function(search) {


        return $http.get("/user?search=" + search).then(function(results) {

            return results.data;

        });
    };


    /*
     * Checks if filters are set
     */
    $scope.filtersAreSet = function() {

        return !_$filter.get("reports").areClear();
    };

    $scope.clearFilters = function() {

        //get filter by symbol
        _$filter.get("reports").clear();
        $timeout(function() {
            $scope.queryList();
        });

    };

    //quering list from server
    $scope.queryList = function() {

        $scope.showLoader = true;

        $http.get("/report", {
            params: {
                "state": JSON.stringify($scope.filters.state.model.value),
                "type": JSON.stringify($scope.filters.type.model.value),
                "category": $scope.filters.category.model ? JSON.stringify($scope.filters.category.model.value) : null,
                "assign": $scope.filters.assign.model.selectedItem ? $scope.filters.assign.model.selectedItem.id : null,
                "dateFrom": $scope.filters.dateFrom.model.value ? moment($scope.filters.dateFrom.model.value).format("YYYY-MM-DD") : null,
                "dateTo": $scope.filters.dateTo.model.value ? moment($scope.filters.dateTo.model.value).format("YYYY-MM-DD") : null,
                "page": $scope.paginator.page //current page

            }
        }).then(function(response) {

            $scope.list = response.data.list; //set results
            $scope.paginator.count = response.data.count; //set current count


            $scope.showLoader = false;

        });

    };



    $scope.onFilter = function(model) {


    };


    $scope.getInitStates = function() {
        $http.get("/reportstate/getinitstates").then(function(response) {
            $scope.filters.state.model.value = response.data;
            $scope.queryList();
        });
    };

    $scope.getInitStates();    
});
